import { EmptyState } from "@/components/shared";
import { History, RotateCcw } from "lucide-react";

const AUDIT_LABELS = {
  listing_delete: "Deleted listing",
  user_delete: "Deleted user",
  master_grant: "Granted Master Pro",
  master_revoke: "Revoked Master Pro",
  user_set_password: "Set user password",
  user_send_reset: "Sent password reset",
  platform_settings_update: "Updated platform settings",
  coupon_create: "Created coupon",
  coupon_status: "Changed coupon status",
  coupon_delete: "Deleted coupon",
  broadcast_send: "Sent announcement",
};

export const AuditTab = ({ auditLogs, onRefresh }) => (
  <>
    <div className="flex items-center justify-between mb-4">
      <div>
        <h2 className="text-xl font-heading font-medium text-ink">Audit Log</h2>
        <p className="text-sm text-mute mt-1">Recent administrative actions — deletions, permission changes, password resets, coupons and platform settings.</p>
      </div>
      <button data-testid="audit-refresh" onClick={onRefresh} className="text-sm border border-line rounded-lg px-3 py-2 text-ink hover:bg-bone inline-flex items-center gap-1.5"><RotateCcw className="h-4 w-4" /> Refresh</button>
    </div>
    {auditLogs.length === 0 ? (
      <div className="bg-white border border-line rounded-xl"><EmptyState icon={History} title="No activity yet" /></div>
    ) : (
      <div className="bg-white border border-line rounded-xl divide-y divide-line overflow-hidden" data-testid="audit-table">
        {/* Column header — desktop only */}
        <div className="hidden md:flex items-center gap-3 bg-bone text-mute text-xs uppercase px-4 py-3">
          <div className="w-44 font-medium">When</div>
          <div className="flex-1 font-medium">Admin</div>
          <div className="w-52 font-medium">Action</div>
          <div className="flex-1 font-medium">Target</div>
        </div>
        {auditLogs.map((l) => (
          <div key={l.id} data-testid={`audit-row-${l.id}`} className="px-4 py-3 flex flex-col md:flex-row md:items-center gap-1.5 md:gap-3 text-sm">
            <div className="md:w-52 md:order-3">
              <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${/(delete|revoke)/.test(l.action) ? "bg-terracotta/10 text-terracotta" : "bg-forest/10 text-forest"}`}>{AUDIT_LABELS[l.action] || l.action}</span>
            </div>
            <div className="md:w-44 md:order-1 text-mute text-xs md:text-sm md:whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</div>
            <div className="flex-1 md:order-2 text-ink truncate">{l.actor_email || "—"}</div>
            <div className="flex-1 md:order-4 text-mute text-xs md:text-sm break-words">{l.target_label || l.target_id || "—"}{l.detail ? ` · ${l.detail}` : ""}</div>
          </div>
        ))}
      </div>
    )}
  </>
);
